/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


function addNoFollowToExternalLinks() {
  const links = document.querySelectorAll('a[href]');
  const currentHost = window.location.hostname;

  links.forEach(link => {
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.hostname !== currentHost) {
        // Get any existing rel values
        let rel = link.getAttribute('rel') || '';
        const relValues = new Set(rel.split(/\s+/).filter(Boolean));

        // Add the recommended ones
        relValues.add('nofollow');
        relValues.add('noopener');
        relValues.add('noreferrer');

        // Update the attribute
        link.setAttribute('rel', Array.from(relValues).join(' '));
      }
    } catch (e) {
      // Ignore malformed or empty links
    }
  });
}

// Run after page load and when Shopify dynamically loads sections
document.addEventListener('DOMContentLoaded', addNoFollowToExternalLinks);
window.addEventListener('shopify:section:load', addNoFollowToExternalLinks);




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
